import TinyDatePicker from "tiny-date-picker";
import validator from "validator";

/*
 * Confirm the delete action before executing
 */
window.confirmEntityDeletion = (message, form) => {
    if (!message || !form) {
        throw new TypeError("Too few arguments");
    }
    if (confirm(message)) {
        form.submit();
    }
};

/*
 * Show datepickers for the selected input fields
 */
window.addEventListener("load", () => {
    const datepickers = document.querySelectorAll(".datepicker input");

    if (datepickers.length) {
        datepickers.forEach(node => {
            // Initiate a datepicker
            const isDeliveryDateInput = node.getAttribute("name") === "delivery_date";

            const options = {
                dayOffset: 1,
                format(date) {
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // +1 because months are 0-indexed
                    const day = String(date.getDate()).padStart(2, '0');
                    return `${year}-${month}-${day}`;
                },
                lang: {
                    days: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"],
                    months: [
                        "Januari",
                        "Februari",
                        "Mars",
                        "April",
                        "Maj",
                        "Juni",
                        "Juli",
                        "Augusti",
                        "September",
                        "Oktober",
                        "November",
                        "December"
                    ],
                    today: "Idag",
                    clear: "Rensa",
                    close: "Stäng"
                }
            };

            if (isDeliveryDateInput) {
                const today = new Date();
                options.min = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            }

            TinyDatePicker(node, options);
        });
    }

    const fileInputs = document.querySelectorAll(".custom-file-input");

    if (fileInputs.length) {
        fileInputs.forEach(node => {
            node.addEventListener("change", event => {
                const fileName = event.target.value;
                node.nextElementSibling.classList.add("selected");
                node.nextElementSibling.innerHTML = fileName;
            });
        });
    }

    const formSubmitToggles = document.querySelectorAll(
        'input[type="checkbox"].js-toggleFormSubmitButton'
    );

    if (formSubmitToggles.length) {
        formSubmitToggles.forEach(node => {
            node.addEventListener("change", event => {
                const button = node.form.querySelector('[type="submit"]');
                if (node.checked) {
                    button.removeAttribute("disabled");
                } else {
                    button.setAttribute("disabled", true);
                }
            });
        });
    }

    /**
     * Run validation on the CostEstimate forms
     */
    const formActionButtons = document.querySelectorAll(
        ".actionButtons button"
    );

    if (formActionButtons.length) {
        formActionButtons.forEach(node => {
            const form = node.form || false;
            if (
                form &&
                (form.getAttribute("name") === "costEstimateCreateForm" ||
                    form.getAttribute("name") === "costEstimateEditForm")
            ) {
                node.addEventListener("click", event => {
                    let errorField = "";
                    let errorMessage = "";
                    let validated = true;

                    if (event.target.name != "saveAsTemplate") {
                        const customerId = form.querySelector(
                            'input[name="customer_id"]'
                        ).value;

                        if (!validator.isInt(customerId, { min: 1 })) {
                            validated = false;
                            errorField = "customer_id";
                            errorMessage = "Välj en kund";
                        }
                    }

                    if (validated) {
                        // Dispatch a global event
                        const customEvent = new CustomEvent(
                            "cost-estimate:validationError",
                            {
                                detail: {}
                            }
                        );
                        window.dispatchEvent(customEvent);
                    } else {
                        // Dispatch a global event
                        const customEvent = new CustomEvent(
                            "cost-estimate:validationError",
                            {
                                detail: {
                                    errorMessage,
                                    errorField
                                }
                            }
                        );
                        window.dispatchEvent(customEvent);

                        event.preventDefault();
                    }
                });
            }
        });
    }
});

/*
 * Listen for messages from iframe dialogues
 */
window.addEventListener("message", event => {
    const { document: d } = window;
    const host = d.location.protocol + "//" + d.location.host;

    if (event.origin !== host) return;

    if (event.data.length > 0) {
        const { action, url } = JSON.parse(event.data);
        if (action && url) {
            if ("closeDialogue" === action) {
                window.location.assign(url);
            }
        }
    }
});

var path = window.location.pathname.split('/');
var last = path.pop();

if ($('.fn-color').length > 0 && $('.fn-color-list').length > 0 && last === 'edit' || last === 'create') {
    function rgb2hex(rgb) {
        if (  rgb.search("rgb") == -1 ) {
             return rgb;
        } else {
             rgb = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+))?\)$/);
             function hex(x) {
                  return ("0" + parseInt(x).toString(16)).slice(-2);
             }
             return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]); 
        }
   }

    $('.fn-color-list li').on('click', function() {
        console.log('clicked: ');
        $('.color-pal__select__list__item--active').removeClass('color-pal__select__list__item--active');
        $(this).addClass('color-pal__select__list__item--active');
        $('.fn-color').val(rgb2hex($(this).css('background-color')));
    });
}